export default { 'GiTextInput.go': { en: 'Go', fr: 'Aller' } };
